export class Familiar{
  
		public idFamilar:number;
		public nombre:string;
		public apellidoP:string;
		public apellidoM:string;
		public relacion:number;
		public accion: number;
		public nombreP: string;
		public apellidopP: string;
		public idPersonal: number;
		public fecha: any;
	
}


// WEBPACK FOOTER //
// ./src/app/models/familiar.ts